import React from "react";

const EventsPage = () => {
  return (
    <div>
      <h1>Events Page</h1>
      <p>List of events will go here.</p>
    </div>
  );
};

export default EventsPage;
